import { Instance, types } from 'mobx-state-tree'

export const UIStore = types
  .model('UIStore', {
    leftNavigationIsExpanded: false,
  })
  .actions(self => ({
    toggleLeftNavigation() {
      self.leftNavigationIsExpanded = !self.leftNavigationIsExpanded
    },
  }))

export interface IUIStore extends Instance<typeof UIStore> {}
